import { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import GuiaIndv from "./GuiaIndv";
import { RootState, useAppDispatch } from "../../../redux/store";
import { clearGuiaPrevisualizar, clearProductosDisponibles, getGuiaProformaParaImprimir } from "../../../redux/actions/actionsCrear";
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux';
import Loading from '../../helpers/Loading/Loading';

const ImprimirContent = () => {

  const dispatch = useAppDispatch()
  const { numeroGuia } = useParams()
  const infoGuiaProformaStore = useSelector((state: RootState) => state.crear.guiaProformaImprimir)
  const guiaProformaStore = infoGuiaProformaStore.info
  useEffect(() => {
    if (numeroGuia) {
      const consGuia = numeroGuia.split("-")
      dispatch(getGuiaProformaParaImprimir(consGuia[0], consGuia[1], Number(consGuia[2])))
    }
    return(
      dispatch(clearGuiaPrevisualizar())
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numeroGuia])


  const handlePrint = () => {
    const buttons = window.document.getElementById('pintBtnsGuia') as HTMLButtonElement
    const tablas = window.document.getElementsByClassName('tablasIndvImprimir') as HTMLCollectionOf<HTMLTableElement>
    const sideBar = window.document.getElementsByClassName('sidebar-wrapper') as HTMLCollectionOf<HTMLDivElement>
    if (buttons && tablas) {
      if(sideBar[0]) sideBar[0].style.display= 'none'
      
      buttons.style.visibility = 'collapse';
      for (let i = 0; i < tablas.length; i++) {
        tablas[i].style.display = 'inline-table'
      }
      window.print()
      
      for (let i = 0; i < tablas.length; i++) {
        tablas[i].style.display = ""
      }
      if(sideBar[0]) sideBar[0].style.display= ''
      buttons.style.visibility = 'visible';
    }
  }


  const navigate = useNavigate()

  const handleNuevaGuia = async () => {
    dispatch(clearGuiaPrevisualizar())
    dispatch(clearProductosDisponibles())
    navigate("/home/crear/guia")
  }

  return (
    infoGuiaProformaStore.loading === false?
      <div id="content" className="main-container">
        <div className="layout-px-spacing">
          <div className="row invoice layout-top-spacing layout-spacing">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="doc-container">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="invoice-container">
                      <div className="invoice-inbox">
                        <div id="ct" className="">
                          <div className="invoice-00001" id='tablaIndv1'>
                            <GuiaIndv guiaProforma={guiaProformaStore} identificador='tablaIndv1' />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="row invoice layout-top-spacing layout-spacing">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="doc-container">
                      <div className="row">
                        <div className="col-xl-12">
                          <div className="invoice-container">
                            <div className="invoice-inbox">
                              <div id="ct" className="">
                                <div className="invoice-00001" id='tablaIndv2'>
                                  <GuiaIndv guiaProforma={guiaProformaStore} identificador='tablaIndv2'/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="row invoice layout-top-spacing layout-spacing">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                          <div className="doc-container">
                            <div className="row">
                              <div className="col-xl-12">
                                <div className="invoice-container">
                                  <div className="invoice-inbox">
                                    <div id="ct" className="">
                                      <div className="invoice-00001" id='tablaIndv3'>
                                        <GuiaIndv guiaProforma={guiaProformaStore} identificador='tablaIndv3'/>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                            <div className="doc-container">
                              <div className="row">
                                <div className="col-xl-12">
                                  <div className="invoice-container">
                                    <div className="invoice-inbox">
                                      <div id="ct" className="">
                                        <div className="invoice-00001" id='tablaIndv4'>
                                        <GuiaIndv guiaProforma={guiaProformaStore} identificador='tablaIndv4'/>
                                      </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          <div className="invoice-action-btn" id="pintBtnsGuia">
                            <div className="row d-flex justify-content-around ">
                              <div >
                                <button
                                  onClick={() => handlePrint()}
                                  className="btn btn-secondary btn-print  action-print mb-1 mt-1"
                                >
                                  Imprimir
                                </button>
                              </div>
                              <div
                              >
                                <button
                                  className="btn btn-primary btn-send mb-1 mt-1"
                                  onClick={() => handleNuevaGuia()}
                                >
                                  {" "}
                                  Nuevo
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      :
      <div id="content" className="main-container d-flex justify-content-center">
        {infoGuiaProformaStore.errorUndefined ?
          <span className='text-danger text-center'>{`${infoGuiaProformaStore.errorUndefined}`}</span>
          :<div className='mt-4'>
            <Loading />
          </div>
          }
      </div>
  );
};

export default ImprimirContent;
